import { Spin } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CenterDiv = styled.div<SpinnerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${(props) => (props.absolute ? 'absolute' : 'auto')};
  height: ${(props) => (props.absolute ? '100vh' : '100%')};
  width: ${(props) => (props.absolute ? '100vw' : '100%')};
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.85);
`;

const StyledSpin = styled(Spin)`
  &&& {
    padding: 20px;
    background: white;
    border-radius: 20px;
  }
`;

export interface SpinnerProps {
  absolute: boolean;
}

const Spinner = ({ absolute }: SpinnerProps) => {
  const [t] = useTranslation('geosecma-settings');

  return (
    <CenterDiv absolute={absolute}>
      <StyledSpin size="large" tip={t('loadingSettings')} data-testid="loadingSpinner" />
    </CenterDiv>
  );
};

Spinner.defaultProps = {
  absolute: false
};

export default Spinner;
